import { motion } from "framer-motion";
import { MessageCircleQuestion, CloudFog, Sparkles } from "lucide-react";

const ICONS = [MessageCircleQuestion, CloudFog, Sparkles];

const Manifesto = ({ t }) => (
  <section data-testid="manifesto-section" className="relative z-10 mx-auto max-w-6xl px-6 pb-8 pt-6 text-center">
    <motion.p
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.7 }}
      className="mb-2 text-sm font-medium uppercase tracking-[0.4em] text-amber-500/80"
    >
      {t.ritual}
    </motion.p>
    <motion.h2
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.9, delay: 0.8 }}
      className="mb-6 font-serif text-2xl font-light tracking-tight text-white/90 sm:text-3xl"
    >
      {t.manifestoTitle}
    </motion.h2>

    <div className="grid grid-cols-1 gap-5 text-left md:grid-cols-3 md:gap-6">
      {t.chapters.map((c, i) => {
        const Icon = ICONS[i];
        return (
          <motion.article
            key={c.num}
            data-testid={`manifesto-chapter-${c.num}`}
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.9 + i * 0.15, ease: [0.22, 1, 0.36, 1] }}
            className="rounded-2xl border border-white/5 bg-[#0F0728]/60 p-5 backdrop-blur-sm transition-colors duration-500 hover:border-amber-500/20"
          >
            <div className="mb-2 flex items-baseline justify-between">
              <span className="font-serif text-3xl font-light text-amber-500/80">{c.num}</span>
              <Icon className="h-5 w-5 text-white/30" strokeWidth={1.5} />
            </div>
            <h3 className="mb-1.5 font-serif text-xl font-normal tracking-tight text-white/95">{c.title}</h3>
            <p className="text-sm leading-relaxed text-slate-300">{c.text}</p>
          </motion.article>
        );
      })}
    </div>
  </section>
);

export default Manifesto;
